import * as React from "react";

export function PsycheRadarSpokeLayers({ controller }: { controller: any }) {
    const spokeRenderData: any[] = controller.spokeRenderData;

    return (
        <>
            {spokeRenderData.map((item: any) => {
                const { spoke, isActive, spokeOpacity, arePathsHidden, spokeVisibility, dashSegments, spokeStroke, isEntering, isVisibleNewSpoke, handlePoint } = item;

                return (
                <g
                    key={`${spoke.id}-underlay`}
                    filter="url(#soft-shadow)"
                    style={
                        isEntering
                            ? {
                                  opacity: isVisibleNewSpoke && !arePathsHidden ? spokeOpacity : 0,
                                  transformOrigin: `${handlePoint.x}px ${handlePoint.y}px`,
                                  transform: isVisibleNewSpoke ? "scale(1)" : "scale(0.94)",
                                  transition: "opacity 620ms ease-out, transform 620ms ease-out",
                              }
                            : { opacity: arePathsHidden ? 0 : spokeOpacity }
                    }
                >
                    {dashSegments.map((segment: any, segmentIndex: number) => (
                        <path
                            key={`${spoke.id}-dash-${segmentIndex}`}
                            d={`M ${segment.start.x} ${segment.start.y} L ${segment.end.x} ${segment.end.y}`}
                            fill="none"
                        stroke={spokeStroke}
                        strokeWidth={segment.width}
                        strokeLinecap="round"
                        opacity={arePathsHidden ? 0 : isActive ? `${spokeVisibility * 0.5125}` : `${spokeVisibility * 0.45}`}
                        pointerEvents="none"
                        />
                    ))}
                </g>
                );
            })}
            {spokeRenderData.map((item: any) => {
                const { spoke, handlePoint, impactFlare, spokeOpacity, isCenterHiddenByCheckbox } = item;

                if (isCenterHiddenByCheckbox) {
                    return null;
                }

                return (
                <g key={`${spoke.id}-impact-flare`} pointerEvents="none" opacity={spokeOpacity} style={{ mixBlendMode: "screen" }}>
                    <circle cx={handlePoint.x + impactFlare.offsetX} cy={handlePoint.y + impactFlare.offsetY} r={impactFlare.outerRadius} fill={impactFlare.outerColor} opacity={impactFlare.outerOpacity} filter="url(#impact-flare-glow)" />
                    <circle cx={handlePoint.x} cy={handlePoint.y} r={impactFlare.innerRadius} fill={impactFlare.innerColor} opacity={impactFlare.innerOpacity} filter="url(#impact-flare-glow)" />
                </g>
                );
            })}
            {[
                ...spokeRenderData.filter(({ isSelected }: any) => !isSelected),
                ...spokeRenderData.filter(({ isSelected }: any) => isSelected),
            ].map((item: any) => {
                const { spoke, index, isActive, isInteractable, handlePoint, pathD } = item;
                const isLocked = controller.isTouchZoomLocked;
                const canInteractWithPath = !isLocked && isInteractable && !item.arePathsHidden;

                return (
                    <g key={`${spoke.id}-overlay`}>
                        <path
                            d={pathD}
                            fill="none"
                            stroke="transparent"
                            strokeWidth="26"
                            strokeLinecap="round"
                            data-radar-interactive="true"
                            opacity={canInteractWithPath ? "1" : "0"}
                            style={{ cursor: canInteractWithPath ? "grab" : "default", pointerEvents: canInteractWithPath ? "stroke" : "none" }}
                            onPointerEnter={() => {
                                if (!canInteractWithPath) return;
                                controller.setHoveredIndex(index);
                            }}
                            onPointerLeave={() => {
                                if (!canInteractWithPath) return;
                                controller.setHoveredIndex(null);
                            }}
                            onPointerDown={(event) => {
                                if (!canInteractWithPath) return;
                                event.preventDefault();
                                event.stopPropagation();
                                controller.setSelectedIndex((current: number | null) => (current === index ? current : index));
                                controller.setDraggingIndex(index);
                            }}
                        />
                        <circle
                            cx={handlePoint.x}
                            cy={handlePoint.y}
                            r={isActive ? controller.activeNubHitRadius : controller.nubHitRadius}
                            fill="transparent"
                            stroke="transparent"
                            strokeWidth="10"
                            data-radar-interactive="true"
                            opacity={canInteractWithPath ? "1" : "0"}
                            style={{ cursor: canInteractWithPath ? "grab" : "default", pointerEvents: canInteractWithPath ? "all" : "none" }}
                            onPointerEnter={() => {
                                if (!canInteractWithPath) return;
                                controller.setHoveredIndex(index);
                            }}
                            onPointerLeave={() => {
                                if (!canInteractWithPath) return;
                                controller.setHoveredIndex(null);
                            }}
                            onPointerDown={(event) => {
                                if (!canInteractWithPath) return;
                                event.preventDefault();
                                event.stopPropagation();
                                controller.setSelectedIndex((current: number | null) => (current === index ? current : index));
                                controller.setDraggingIndex(index);
                            }}
                        />
                    </g>
                );
            })}
        </>
    );
}
